import React, { useRef,Suspense,useEffect, useState, useCallback,useMemo } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import { setFilters, resetFilters} from 'reducers/filtersNTSlice';
import { resetPagination } from 'reducers/paginationNTsSlice';
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem  from "@mui/material/MenuItem"; 
import TextField from '@mui/material/TextField'; 
import Textarea from '@mui/joy/Textarea';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types'; 
import TableSortingNT from "pages/NT/filterNT/SortingTablesNT";
import NTPDF from "pages/NT/generatePDF/NTPDF" 
import exportNTToExcel from "pages/NT/filterNT/NTExportToExcel";

const initialFiltersNTs= {
  idFrom:"",
  idTo:"",
  defaultStoreIdFrom:"",
  defaultStoreIdTo:"",
  useraccountIdFrom:"",
  useraccountIdTo:"",
  typesdiToES:"",
  typesdiFromEN:"",
  typesdiToEN:"",
  isScanned:true, 
  notIsScanned:true,
  numberNTFrom:"",
  numberNTTo:"",
  dateSheetFrom:null,
  dateSheetTo:null,
  ori_tras_store_idFrom: "", 
  ori_tras_store_idTo: "", 
  dest_tras_store_idFrom:"",
  dest_tras_store_idTo:"" 
}; 

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": "",
  "name": ""
}];

const initialUserAccountToSelect = [{
  "id": "",
  "username":"",
  "firstName": "",
  "lastName1": "",
  "lastName2": "",
  "email": "",
  "aliasuser": ""
}];

const initialStateNT = [{
  "id" : 0,
  "ownformnt_id":0,
  "defaultStore_id" : 0,
  "tradename" : "",
  "useraccount_id" : 0,
  "username" :"",
  "defaultformatnumber": 1,
  "isPending":false,
  "isFinished":true,
  "isScanned":false,
  "number_nt":"",
  "date_sheet":"",

  "opt_tras_store_id" : 0,
  "opt_tras_tradename" : "",
  "opt_tras_nima": "",

  "ori_tras_store_id" : 0,
  "ori_tras_tradename" : "",
  "ori_tras_nima": "",
  "ori_tras_postalcode": "",
  
  "dest_tras_store_id" : 0,
  "dest_tras_tradename" : "",
  "dest_tras_nima" : "",
  "dest_tras_inscription" : "",
  "dest_tras_postalcode" : "",
     
  "rel_trans_store_id" : 0,
  "rel_trans_tradename" : "",
  "rel_trans_nima" : "",
  "rel_trans_licenseplate" : "",
 
  "codeler_code": "",
  "codeler_namees": "",
  "reatmenttypedestine_code": "",
  "treatmenttypedestine_namees": "",
  "processtypedestine_code": "",
  "processtypedestine_namees": "",
    
  "amount":0,
  "hasbeenfinishedscanned":false,
  "hasbeenshared":false,
  "statussentesir":0,
  "reasonrefund":"" ,
  "deliveryamount":0
}];
    

const NTFilter = ({ showModalNTSettings,setShowModalNTSettings}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_NT = useSelector((state) => state.formatDIUser.delete_code_formdi); 
  const [dataNT, setDataNT] = useState(initialStateNT); 
  const filtersNtsDetails = useSelector((state) => state.filtersNTs);
  const [filtersNT, setFiltersNT]= useState(filtersNtsDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegNT,setNumTotRegNT]= useState(0);
  const [errorsfiltersNT, setErrorsfiltersNT] = useState({});
  const [inputTextNT, setInputTextNT] = useState("");  
  const [openDeleteRowNT,setOpenDeleteRowNT]= useState(false); 
  const [openEditRowNT,setOpenEditRowNT]= useState(false);
  const [openEditFilterNT,setOpenEditFilterNT]= useState(false);
  const [rowEditNT,setRowEditNT]= useState(initialStateNT[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorNT, setIsLoadingErrorNT] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const [viewPDF,setViewPDF]=useState(false);  
  const dispatch = useDispatch();
  const [activeOffsetNT, setActiveOffsetNT]= useState(false);
  const [currencyOffsetNT, setCurrencyOffsetNT] = useState(0);
  const [rangeOffsetNT, setRangeOffsetNT] = useState([{}]);
  const [storesToSelect,setStoresToSelect]= useState(initialStoresToSelect);
  const [userAccountsToSelect,setUserAccountsToSelect]= useState(initialUserAccountToSelect);
  const navigate = useNavigate(); 
  const [oriTrasTradenameToSelect,setOriTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [destTrasTradenameToSelect,setDestTrasTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredOriTrasStoreFrom, setFilteredOriTrasStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreFrom, setHighlightedIndexOriTrasStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredOriTrasStoreTo, setFilteredOriTrasStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexOriTrasStoreTo, setHighlightedIndexOriTrasStoreTo] = useState(-1); // Índice de la opción resaltada
  const [filteredTransFrom, setFilteredTransFrom] = useState([]); // Opciones filtradas
  const [filteredDestTrasStoreTo, setFilteredDestTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
  const [filteredTransTo, setFilteredTransTo] = useState([]); // Opciones filtradas
  const [highlightedIndexDestTrasStoreTo, setHighlightedIndexDestTrasStoreTo] = useState(-1); // Índice de la opción resaltada 
  const [openErrorRowNT,setOpenErrorRowNT]= useState(false); 
  const [openVideoHelpStore, setOpenVideoHelpStore] = useState(false);
  const STORE_VIDEO_URL = "https://dn3b0526k2h3y.cloudfront.net/NT.mp4";
  
  const menuPermissions = useMemo(() => {
    const list = roles && roles[0] && roles[0].listmenus ? roles[0].listmenus : [];
    const has = (name) => list.some((m) => m.name === name);
    return {
      storeMaster: has('SubMenu_Settings_NTs_Store_Master'),
      userMaster: has('SubMenu_Settings_NTs_User_Master'),
      canCreate: has('SubMenu_NT_Create'),
      canExcel: has('SubMenu_NT_Handle_Excel'), 
      canEdit: has('SubMenu_NT_Edit'),
      canPrint: has('SubMenu_NT_Print'),
      canDelete: has('SubMenu_NT_Delete'),
      canHandleEmails: has('SubMenu_NT_Handle_EMAILs'),
      canHandleESIR: has('SubMenu_NT_Handle_ESIR'),
      canHandleESIRSEND: has('SubMenu_NT_Handle_ESIR_SEND'),
      canShowStores: has('SubMenu_NT_View_Stores'),  
    };
  }, [roles]);
  
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalNTSettings) {
        setDataNT(initialStateNT);  
        setNumTotRegFilter(0);
        setNumTotRegNT(0);
        setErrorsfiltersNT({});
        setInputTextNT(""); 
        setOpenDeleteRowNT(false); 
        setOpenErrorRowNT(false);
        setOpenEditRowNT(false);
        setOpenEditFilterNT(false);
        setRowEditNT(initialStateNT[0]); 
        setIsLoadingErrorNT(false);
        setIdCodeDelete(DELETE_CODE);
        setViewPDF(false);
        setActiveOffsetNT(false);
        setOpenVideoHelpStore(false);  
        setCurrencyOffsetNT(0);
        setRangeOffsetNT([{}]);
        setStoresToSelect(initialStoresToSelect);
        setUserAccountsToSelect(initialUserAccountToSelect); 
        setShowModalNTSettings(false);
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersNT(initialFiltersNTs);
        setDestTrasTradenameToSelect(initialStoresToSelect);
        setOriTrasTradenameToSelect(initialStoresToSelect);
        setFilteredOriTrasStoreFrom([]);
        setHighlightedIndexOriTrasStoreFrom(-1); 
        setFilteredOriTrasStoreTo([]);  
        setHighlightedIndexOriTrasStoreTo(-1);  
        setFilteredTransFrom([]);
        setFilteredDestTrasStoreTo(-1);  
        setFilteredTransTo([]);
        setHighlightedIndexDestTrasStoreTo(-1);  
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataNT,  
      setFiltersNT,
      setNumTotRegFilter,
      setNumTotRegNT,
      setErrorsfiltersNT,
      setInputTextNT, 
      setOpenDeleteRowNT, 
      setOpenErrorRowNT,
      setOpenEditRowNT,
      setOpenEditFilterNT,
      setRowEditNT, 
      setIsLoadingErrorNT,
      setIdCodeDelete,
      setViewPDF,
      setActiveOffsetNT,
      setCurrencyOffsetNT,
      setRangeOffsetNT,
      setStoresToSelect,
      setUserAccountsToSelect, 
      setShowModalNTSettings,
      showModalNTSettings, 
      setOpenVideoHelpStore,
      navigate,
      dispatch,
      setDestTrasTradenameToSelect,
      setOriTrasTradenameToSelect,
      setFilteredOriTrasStoreFrom,
      setHighlightedIndexOriTrasStoreFrom, 
      setFilteredOriTrasStoreTo,
      setHighlightedIndexOriTrasStoreTo, 
      setFilteredTransFrom,
      setFilteredDestTrasStoreTo, 
      setFilteredTransTo,
      setHighlightedIndexDestTrasStoreTo,  
      DELETE_CODE]
  );

  const closeModalNT = () => {    
    setDataNT(initialStateNT);  
    setNumTotRegFilter(0);
    setNumTotRegNT(0);
    setErrorsfiltersNT({});
    setInputTextNT(""); 
    setOpenDeleteRowNT(false); 
    setOpenErrorRowNT(false);
    setOpenEditRowNT(false);
    setOpenEditFilterNT(false);
    setRowEditNT(initialStateNT[0]); 
    setIsLoadingErrorNT(false);
    setIdCodeDelete(DELETE_CODE);
    setViewPDF(false);
    setActiveOffsetNT(false);
    setCurrencyOffsetNT(0);
    setOpenVideoHelpStore(false);  
    setRangeOffsetNT([{}]);
    setStoresToSelect(initialStoresToSelect);
    setUserAccountsToSelect(initialUserAccountToSelect); 
    setShowModalNTSettings(false);
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersNT(initialFiltersNTs);
    setDestTrasTradenameToSelect(initialStoresToSelect);
    setOriTrasTradenameToSelect(initialStoresToSelect);
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1); 
    setFilteredOriTrasStoreTo([]);  
    setHighlightedIndexOriTrasStoreTo(-1);  
    setFilteredTransFrom([]);
    setFilteredDestTrasStoreTo(-1);  
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);  
    navigate("/home");
    return () => {};
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreFrom(filtered);
    setHighlightedIndexOriTrasStoreFrom(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      ori_tras_store_idFrom: store.tradename || "",
      ori_tras_store_idTo: store.tradename || filtersNT.ori_tras_store_idTo 
    }));
    setFilteredOriTrasStoreFrom([]);
    setHighlightedIndexOriTrasStoreFrom(-1);
  }; 
  const handleKeyDownOriTrasStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreFrom.length === 0 && filtersNT.ori_tras_store_idFrom.trim() === "") {
        setFilteredOriTrasStoreFrom(oriTrasTradenameToSelect);
        setHighlightedIndexOriTrasStoreFrom(0);
      } else {
        setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreFrom >= 0) {
      if (highlightedIndexOriTrasStoreFrom >= 0 && highlightedIndexOriTrasStoreFrom < filteredOriTrasStoreFrom.length) {
        handleSelectOriTrasStoreFrom(filteredOriTrasStoreFrom[highlightedIndexOriTrasStoreFrom]);
      }
    } else if (event.key === "Escape" ) {
      const isValid = oriTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.ori_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          ori_tras_store_idFrom: ""
        }));
      }
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchOriTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredOriTrasStoreTo([]);
      setHighlightedIndexOriTrasStoreTo(-1);
      return;
    }
    const filtered = oriTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersNT.ori_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredOriTrasStoreTo(filtered);
    setHighlightedIndexOriTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectOriTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
    ...filtersNT,
    ori_tras_store_idTo:  store.tradename || ""
  }));
  setFilteredOriTrasStoreTo([]);
  setHighlightedIndexOriTrasStoreTo(-1);
  }; 
  const handleKeyDownOriTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredOriTrasStoreTo.length === 0 && filtersNT.ori_tras_store_idTo.trim() === "") {
        const filtered = oriTrasTradenameToSelect.filter(item=>(item.tradename>=filtersNT.ori_tras_store_idFrom));
        setFilteredOriTrasStoreTo(filtered);
        setHighlightedIndexOriTrasStoreTo(0);
      } else {
        setHighlightedIndexOriTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredOriTrasStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexOriTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexOriTrasStoreTo >= 0) {
      if (highlightedIndexOriTrasStoreTo >= 0 && highlightedIndexOriTrasStoreTo < filteredOriTrasStoreTo.length) {
        handleSelectOriTrasStoreTo(filteredOriTrasStoreTo[highlightedIndexOriTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = oriTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersNT.ori_tras_store_idFrom))
      .some((store) => {
      if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.ori_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
    }); 
    if (!isValid) {
      setFiltersNT(filtersNT => ({
        ...filtersNT,
        ori_tras_store_idTo:  ""
      }));
    }
    setFilteredOriTrasStoreTo([]);
    setHighlightedIndexOriTrasStoreTo(-1);
    }
  };  

  // Dentro del componente
  const debouncedHandleSearchDestTrasStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransFrom(filtered);
    setFilteredDestTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectDestTrasStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dest_tras_store_idFrom: store.tradename || "",
      dest_tras_store_idTo: store.tradename || filtersNT.dest_tras_store_idTo,
    })); 
    setFilteredTransFrom([]);
    setFilteredDestTrasStoreTo(-1);
  }; 
  const handleKeyDownTransFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransFrom.length === 0 && filtersNT.dest_tras_store_idFrom.trim() === "") {
        setFilteredTransFrom(destTrasTradenameToSelect);
        setFilteredDestTrasStoreTo(0);
      } else {
        setFilteredDestTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredTransFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setFilteredDestTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && filteredDestTrasStoreTo >= 0) {
      if (filteredDestTrasStoreTo >= 0 && filteredDestTrasStoreTo < filteredTransFrom.length) {
        handleSelectDestTrasStoreFrom(filteredTransFrom[filteredDestTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = destTrasTradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.dest_tras_store_idFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          dest_tras_store_idFrom: "" 
        })); 
      }
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchDestTrasStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
      return;
    }
    const filtered = destTrasTradenameToSelect
      .filter(store=>(store.tradename>=filtersNT.dest_tras_store_idFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredTransTo(filtered);
    setHighlightedIndexDestTrasStoreTo(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectDestTrasStoreTo = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dest_tras_store_idTo:store.tradename || ""
    })); 
    setFilteredTransTo([]);
    setHighlightedIndexDestTrasStoreTo(-1);
  }; 
  const handleKeyDownDesrTrasStoreTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTransTo.length === 0 && filtersNT.dest_tras_store_idTo.trim() === "") {
        const filtered = destTrasTradenameToSelect.filter(item=>(item.tradename>=filtersNT.dest_tras_store_idFrom));
        setFilteredTransTo(filtered);
        setHighlightedIndexDestTrasStoreTo(0);
      } else {
        setHighlightedIndexDestTrasStoreTo((prevIndex) => {
          const nextIndex = prevIndex < filteredTransTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDestTrasStoreTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasStoreTo >= 0) {
      if (highlightedIndexDestTrasStoreTo >= 0 && highlightedIndexDestTrasStoreTo < filteredTransTo.length) {
        handleSelectDestTrasStoreTo(filteredTransTo[highlightedIndexDestTrasStoreTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = destTrasTradenameToSelect
      .filter(item=>(item.tradename>=filtersNT.dest_tras_store_idFrom))
      .some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersNT.dest_tras_store_idTo.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersNT(filtersNT => ({
          ...filtersNT,
          dest_tras_store_idTo: ""
        }));
      }
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
    }
  };  

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredOriTrasStoreFrom([]);
      setHighlightedIndexOriTrasStoreFrom(-1); 
      setFilteredOriTrasStoreTo([]);  
      setHighlightedIndexOriTrasStoreTo(-1);   
      setFilteredTransFrom([]);
      setFilteredDestTrasStoreTo(-1); 
      setFilteredTransTo([]);
      setHighlightedIndexDestTrasStoreTo(-1);
    }
  }, []); 
 
  const openCreateOrEditdataNT = () => {
    setInputTextNT(""); 
    setOpenEditFilterNT(!openEditFilterNT);
    navigate("/ntdetail/0");
  };
   
  const openEditfiltersNT = () => { 
    setOpenEditFilterNT(!openEditFilterNT);
  };

  const handleSubmitFilterEditNT = () => {
    setErrorsfiltersNT(validateFormFilterNT());
    if (Object.keys(errorsfiltersNT).length === 0) {
      setErrorsfiltersNT({}); 
      dispatch(resetPagination());
      dispatch(setFilters(filtersNT));  
      setOpenEditFilterNT(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeletefiltersNT = () => {
    setErrorsfiltersNT({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersNT(initialFiltersNTs); 
    setOpenEditFilterNT(!openEditFilterNT);
  };

  const handleCancelfiltersNT = () => {
    setErrorsfiltersNT({});
    setOpenEditFilterNT(!openEditFilterNT);
  };
 
  const handleChangeSelectDateNT = (event) => {
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dateSheetFrom: event!==null?new Date(event):null,
      dateSheetTo:null
    }));
  };

  const handleBlurSelectDateNTFrom = (e) => {
    handleChangeSelectDateNT(e);
    setErrorsfiltersNT(validateFormFilterNT());
  };

  const handleChangeSelectDateNTTo = (event) => {
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      dateSheetTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateNTTo = (e) => {
    handleChangeSelectDateNTTo(e);
    setErrorsfiltersNT(validateFormFilterNT());
  };
    
  const handleChangeFilterEditNT = (e) => {
    const { name, value } = e.target;
    setFiltersNT(filtersNT => ({
      ...filtersNT,
      [name]: value
    }));
  };

  const handleBlurFilterEditNT = (e) => {
    setErrorsfiltersNT(validateFormFilterNT());
    handleChangeFilterEditNT(e);
  };

  const toggleDrawerFilterEditNT = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditNT();
    }
  };

  const validateFormFilterNT = () => {

    let errorsfiltersNT = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersNT.idFrom!=="" & !regexNumber.test(filtersNT.idFrom)) {
      errorsfiltersNT.idFrom = 'Text_TextNoNumber';
    }
    if (filtersNT.idTo!=="" & !regexNumber.test(filtersNT.idTo)) {
      errorsfiltersNT.idTo = 'Text_TextNoNumber';
    }
    if (filtersNT.idFrom!=="" & !errorsfiltersNT.idFrom!==undefined){
      if (filtersNT.idTo!=="" & !errorsfiltersNT.idTo!==undefined){
        if (parseInt(filtersNT.idTo)<parseInt(filtersNT.idFrom)){
          errorsfiltersNT.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (filtersNT.defaultStoreIdTo!=="" & filtersNT.defaultStoreIdTo<filtersNT.defaultStoreIdFrom){
      errorsfiltersNT.defaultStoreIdTo = 'Text_TextGreater_Store';
    }

    if (filtersNT.useraccountIdTo!=="" & filtersNT.useraccountIdTo<filtersNT.useraccountIdFrom){
      errorsfiltersNT.useraccountIdTo = 'Text_TextGreater_UserAccount';
    }

    if (regexInvalidCharacters.test(filtersNT.numberNTFrom)) {
      errorsfiltersNT.numberNTFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersNT.numberNTTo)) {
      errorsfiltersNT.numberNTTo = 'Text_TextNoValid';
    }

    if (filtersNT.numberNTTo!=="" & filtersNT.numberNTTo<filtersNT.numberNTFrom){
      errorsfiltersNT.numberNTTo = 'Text_TextGreater_numberNTTo';
    }

    if (filtersNT.dateSheetTo!==null & filtersNT.dateSheetTo<filtersNT.dateSheetFrom){
      errorsfiltersNT.dateSheetTo = 'Text_TextGreater_Date';
    }
    return errorsfiltersNT;
  }  

  const filtereddataNT = dataNT.filter((el) => {
    if (inputTextNT === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') + 
        String(el.number_nt || '');
      let result = dataTranslate.toLowerCase().includes(inputTextNT.toLowerCase());
      return result;
    }
  })

  let inputHandlerNT = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextNT(lowerCase);
  };

  const handleChangeDeleteRowNT = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowNT = () => {
    setRowEditNT(initialStateNT[0]);
    setIsLoadingErrorNT(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowNT(false);
  };

  const handleCancelErrorRowNT = () => {
    setRowEditNT(initialStateNT[0]);
    setIsLoadingErrorNT(false);
    setOpenErrorRowNT(false);
  };

  const handleCloseDeleteRowNT = (e) => {
    if (idCodeDelete !== DELETE_CODE_NT) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditNT.id!=='') {      
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT,`nt/deletent  `,token,rowEditNT);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
                handleCloseDataEditNT();
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowNT(false);
    setIsLoadingErrorNT(false);
    handleCloseDataEditNT(); 
  };
 
  const handleCloseDataEditNT = () => { 
    setOpenEditRowNT(false);
    setRowEditNT(openEditRowNT?rowEditNT:initialStateNT[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorNT(false);
    toggleDrawerFilterEditNT(false);  
	};
  
  const handleExport = () => { 
    const fetchDataNT = async () => {
      dispatch(setLoading(true));
      try {
        const getData =
        menuPermissions.storeMaster ?
        await helpHttp().post7(ENDPOINT,`nt/getnttoexcel`,token,currencyOffsetNT,LIMIT_PAGE,"-1","-1",filtersNtsDetails):
        menuPermissions.userMaster ?
        await helpHttp().post7(ENDPOINT,`nt/getnttoexcel`,token,currencyOffsetNT,LIMIT_PAGE,defaultStore.id,"-1",filtersNtsDetails):
        await helpHttp().post7(ENDPOINT,`nt/getnttoexcel`,token,defaultStore.id,useraccount_id,filtersNtsDetails);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (getData && getData.length>0) {
          exportNTToExcel(getData, "NOTIFICACIONES PREVIAS"); 
        }
        dispatch(setLoading(false)); 
      } catch (error) {
        dispatch(setLoading(false)); 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    if (dataNT && dataNT.length>0){ 
      fetchDataNT();
    } 
  };
  
  useEffect(() => {
    if (numTotRegNT > Number(LIMIT_PAGE)) {
      setActiveOffsetNT(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegNT; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetNT(newRangeOffset);
    } else {
      setCurrencyOffsetNT(0);
      setActiveOffsetNT(false);
      setRangeOffsetNT([{}]);
    }
  }, [numTotRegNT]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataOriTras = async () => {
      try {
        const getData =
        menuPermissions.storeMaster ?
        await helpHttp().get8(ENDPOINT,`nt/gelisttradenament`,token,"-1","-1"):
        menuPermissions.userMaster ?
        await helpHttp().get8(ENDPOINT,`nt/gelisttradenament`,token,defaultStore.id,"-1"):
        await helpHttp().get8(ENDPOINT,`nt/gelisttradenament`,token,defaultStore.id,useraccount_id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setOriTrasTradenameToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchDataDestTras = async () => {
      try {
        const getData =
        menuPermissions.storeMaster ?
        await helpHttp().get8(ENDPOINT,`nt/getlistdestinent`,token,"-1","-1"):
        menuPermissions.userMaster ?
        await helpHttp().get8(ENDPOINT,`nt/getlistdestinent`,token,defaultStore.id,"-1"):
        await helpHttp().get8(ENDPOINT,`nt/getlistdestinent`,token,defaultStore.id,useraccount_id);
      if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDestTrasTradenameToSelect(getData); 
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   

    if (showModalNTSettings ) { 
      fetchDataOriTras();
      fetchDataDestTras();  
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,defaultStore.id,useraccount_id,openEditFilterNT,showModalNTSettings,menuPermissions.storeMaster,menuPermissions.userMaster]);
    
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegNT = async () => { 
      try {
        const getData  =  menuPermissions.storeMaster ?
        await helpHttp().get(ENDPOINT,`nt/getinformationtablent`,token): 
        menuPermissions.userMaster ?
            await helpHttp().get2(ENDPOINT,`nt/getInformationtablentwithstore/`,token,defaultStore.id):
            await helpHttp().get8(ENDPOINT,`nt/getInformationtablentwithstoreanduseraccount`,token,defaultStore.id,useraccount_id)
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataNT(initialStateNT);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            }  
          }
        } else if (isMounted) {
          setNumTotRegNT(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = 
        menuPermissions.storeMaster ?
        await helpHttp().get3(ENDPOINT,`nt/getcountfilternt`,token,"-1","-1",filtersNtsDetails):
        menuPermissions.userMaster ?
        await helpHttp().get3(ENDPOINT,`nt/getcountfilternt`,token,defaultStore.id,"-1",filtersNtsDetails):
        await helpHttp().get3(ENDPOINT,`nt/getcountfilternt`,token,defaultStore.id,useraccount_id,filtersNtsDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataNT(initialStateNT);
            if (getData.message==="Load failed"){
              dispatch(warningErrorAction(t('Text_ConnectionFailied')));
            }else {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } 
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    }; 
 
    const fetchDataStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`nt/storesorderbytradename`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataUserAccount = async () => {
      try {
        const getData = 
          menuPermissions.storeMaster ?
            await helpHttp().get2(ENDPOINT,`nt/useraccountsorderbyusername/`,token,"-1"):
            await helpHttp().get2(ENDPOINT,`nt/useraccountsorderbyusername/`,token,defaultStore.id);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setUserAccountsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

    const fetchdataNT = async () => {
      dispatch(setLoading(true));
      try {
        const getData = 
        menuPermissions.storeMaster ?
        await helpHttp().post7(ENDPOINT,`nt/getformsnt`,token,currencyOffsetNT,LIMIT_PAGE,"-1","-1",filtersNtsDetails):
        menuPermissions.userMaster ?
        await helpHttp().post7(ENDPOINT,`nt/getformsnt`,token,currencyOffsetNT,LIMIT_PAGE,defaultStore.id,"-1",filtersNtsDetails):
        await helpHttp().post7(ENDPOINT,`nt/getformsnt`,token,defaultStore.id,useraccount_id,filtersNtsDetails);
        if (getData.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataNT(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
 
    if (showModalNTSettings){
      fetchnumTotRegNT();
      fetchnumTotRegFilter(); 
      fetchdataNT();
      if (menuPermissions.storeMaster){
        fetchDataStore();
      }
      if (menuPermissions.userMaster){
        fetchDataUserAccount();
      } 
    }  
    return () => { isMounted = false; };
  }, [t,token,dispatch,i18n.language,filtersNtsDetails,showModalNTSettings,currencyOffsetNT,defaultStore.id,useraccount_id ,openDeleteRowNT,setOpenDeleteRowNT,setOpenEditRowNT,openEditRowNT,rowEditNT,setRowEditNT,defaultStore,menuPermissions.storeMaster,menuPermissions.userMaster ]);
  
  return (
    <>
       {showModalNTSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorNT?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowNT?"warning":"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_NT_Table')}
            </h1>
              <div className="formdi-pending-header-actions"> 
            
              {menuPermissions.canCreate ? (
                <div>
                  <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditdataNT} >
                    {t('Button_Create')}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalNT} >
                    {t("Button_Back")}
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalNT} >
                    {t("Button_Back")}
                  </button>
                </div>
              )} 
              <div
                className="video-tutorial-cta"
                onClick={() => setOpenVideoHelpStore(true)}
                title={t('Text_Video_View')}
              >
                <div className="video-tutorial-cta__circle">
                  <i className="fas fa-play"></i>
                </div>

                <div className="video-tutorial-cta__pill">
                  <span className="video-tutorial-cta__tag">{t('Text_Video_Tutorial')}</span>
                  <span className="video-tutorial-cta__title">{t('Button_Video')}</span>
                </div>
              </div> 
            </div>  
          </div>  
          <br/>
          {/* Buscador */}
          <div className="formdi-pending-search"> 
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextNT}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_FORM_Search')} 
              onChange={inputHandlerNT}
              fullWidth
              label={t('Text_FORM_Search')}>
            </TextField>
          </div>
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.idFrom!=="" || filtersNtsDetails.idTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                <span className={`formdi-pending-dot ${filtersNtsDetails.idFrom!=="" || filtersNtsDetails.idTo!==""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button> 
              {menuPermissions.storeMaster &&
                <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.defaultStoreIdFrom !== "" || filtersNtsDetails.defaultStoreIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                  <span className={`formdi-pending-dot ${ filtersNtsDetails.defaultStoreIdFrom !== "" || filtersNtsDetails.defaultStoreIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Store")}
                </button> 
              }
              {menuPermissions.userMaster &&
                <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.useraccountIdFrom !== "" || filtersNtsDetails.useraccountIdTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                  <span className={`formdi-pending-dot ${ filtersNtsDetails.useraccountIdFrom !== "" || filtersNtsDetails.useraccountIdTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_UserAccount")}
                </button>
              }
              <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.numberNTFrom!=="" || filtersNtsDetails.numberNTTo!==""? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                <span className={`formdi-pending-dot ${filtersNtsDetails.numberNTFrom!=="" || filtersNtsDetails.numberNTTo!==""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NT_NUMBER")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.dateSheetFrom!==null|| filtersNtsDetails.dateSheetTo!==null? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                <span className={`formdi-pending-dot ${filtersNtsDetails.dateSheetFrom!==null|| filtersNtsDetails.dateSheetTo!==null? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_NT_DATE")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersNtsDetails.ori_tras_store_idFrom 
                      || filtersNtsDetails.ori_tras_store_idTo
                      || filtersNtsDetails.dest_tras_store_idFrom
                      || filtersNtsDetails.dest_tras_store_idTo ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersNT} >
                <span className={`formdi-pending-dot ${filtersNtsDetails.ori_tras_store_idFrom 
                      || filtersNtsDetails.ori_tras_store_idTo
                      || filtersNtsDetails.dest_tras_store_idFrom
                      || filtersNtsDetails.dest_tras_store_idTo ? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Others_Filters")}
              </button>
              {menuPermissions.canExcel&&
                <>
                  <button type="button" className="formdi-excel-chip" onClick={handleExport}>{t('Button_Excel')}</button><> </> 
                </>
              }    
            </div>
          </div>
          <br/>
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingNT
                      dataNT={filtereddataNT} 
                      numTotRegFilter={ numTotRegFilter}
                      titleTable={t('Text_NT_Table')}
                      setOpenDeleteRowNT={setOpenDeleteRowNT}
                      setOpenErrorRowNT={setOpenErrorRowNT}
                      setRowEditNT={setRowEditNT}
                      showEditButtonNT={menuPermissions.canEdit}
                      showPrintButtonNT={menuPermissions.canPrint}
                      showDeleteButtonNT={menuPermissions.canDelete}
                      showEmailButtonNT={menuPermissions.canHandleEmails}
                      showESIRButton={menuPermissions.canHandleESIR}
                      showESIRButtonSEND={menuPermissions.canHandleESIRSEND}
                      showStoreNT={menuPermissions.canShowStores}
                      showUserAccountNT={menuPermissions.userMaster}
                      numTotRegNT={numTotRegNT}
                      activeOffsetNT={activeOffsetNT}
                      rangeOffsetNT={rangeOffsetNT}
                      currencyOffsetNT={currencyOffsetNT}
                      setCurrencyOffsetNT={setCurrencyOffsetNT} 
                      setViewPDF={setViewPDF} 
                    > 
                    </TableSortingNT>
                </div>             
              </div>
              
              {openEditFilterNT &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditNT(false)}
                 onOpen={toggleDrawerFilterEditNT(true)}>
                <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfilternt" onSubmit={handleCancelfiltersNT}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filtersNT.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersNT.idFrom!=null?t(errorsfiltersNT.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditNT}
                              onChange={handleChangeFilterEditNT}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersNT.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersNT.idTo!=null?t(errorsfiltersNT.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditNT}
                              onChange={handleChangeFilterEditNT}/>
                           </div>
                           {menuPermissions.storeMaster   &&
                              <>
                                <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                  <div className="form-group">
                                    <TextField
                                      id="defaultStoreIdFrom"
                                      name="defaultStoreIdFrom"
                                      value={filtersNT.defaultStoreIdFrom}
                                      inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersNT.defaultStoreIdFrom!=null?t(errorsfiltersNT.defaultStoreIdFrom):t('Text_Filter_Store_From')}
                                      placeholder={t('PlaceHolder_Filter_Store_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditNT}
                                      onChange={handleChangeFilterEditNT}
                                      select
                                      SelectProps={{
                                      native: true,
                                      }}>
                                      <option key={0} value=""/>
                                      {storesToSelect.map((option) => (
                                          <option key={option.id} value={option.id}>
                                             {option.documentid+" - "+option.tradename}
                                          </option>
                                      ))}
                                    </TextField>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                        id="defaultStoreIdTo"
                                        name="defaultStoreIdTo"
                                        value={filtersNT.defaultStoreIdTo}  
                                        inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        label={errorsfiltersNT.defaultStoreIdTo!=null?t(errorsfiltersNT.defaultStoreIdTo):t('Text_Filter_Store_To')}
                                        placeholder={t('PlaceHolder_Filter_Store_to')}
                                        variant="outlined"
                                        onBlur={handleBlurFilterEditNT}
                                        onChange={handleChangeFilterEditNT}
                                        select
                                        SelectProps={{
                                        native: true,
                                        }}>
                                         <option key={0} value=""/>
                                        {storesToSelect.filter(item=>(item.id>=filtersNT.defaultStoreIdFrom)).map(option => (
                                          <option key={option.id} value={option.id}>
                                              {option.documentid+" - "+option.tradename}
                                          </option>
                                        ))}
                                      </TextField>
                                    </div>
                                </Suspense>
                            </>
                           }   
                           { menuPermissions.userMaster  &&
                              <>
                                <Suspense delayMs={500} fallback={<CircularProgress sx={{ color :"#f6c23e"}}/>}>
                                  <div className="form-group">
                                    <TextField
                                      id="useraccountIdFrom"
                                      name="useraccountIdFrom"
                                      value={filtersNT.useraccountIdFrom}
                                      inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersNT.useraccountIdFrom!=null?t(errorsfiltersNT.useraccountIdFrom):t('Text_Filter_UserAccount_From')}
                                      placeholder={t('PlaceHolder_UserAccount_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditNT}
                                      onChange={handleChangeFilterEditNT}
                                      select
                                      SelectProps={{
                                      native: true,
                                      }}>
                                      <option key={0} value=""/>
                                      {userAccountsToSelect.map((option) => (
                                          <option key={option.id} value={option.username}>
                                            {option.username+" - "+option.email}
                                          </option>
                                      ))}
                                    </TextField>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                        id="useraccountIdTo"
                                        name="useraccountIdTo"
                                        value={filtersNT.useraccountIdTo}  
                                        inputProps={{ style: {width: 382,  fontSize: '18px', }, maxLength: 100 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        label={errorsfiltersNT.useraccountIdTo!=null?t(errorsfiltersNT.useraccountIdTo):t('Text_Filter_UserAccount_To')}
                                        placeholder={t('PlaceHolder_UserAccount_To')}
                                        variant="outlined"
                                        onBlur={handleBlurFilterEditNT}
                                        onChange={handleChangeFilterEditNT}
                                        select
                                        SelectProps={{
                                        native: true,
                                        }}>
                                         <option key={0} value=""/>
                                        {userAccountsToSelect.filter(item=>(item.username>=filtersNT.useraccountIdFrom)).map(option => (
                                          <option key={option.id} value={option.username}>
                                              {option.username+" - "+option.email}
                                          </option>
                                        ))}
                                      </TextField>
                                    </div>
                                </Suspense>
                            </>
                           }   
                           <div className="form-group">
                             <TextField
                              id="numberNTFrom" 
                              name="numberNTFrom"
                              value={filtersNT.numberNTFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsfiltersNT.numberNTFrom!=null?t(errorsfiltersNT.numberNTFrom):t('Text_Filter_NumberNT_From')}
                              placeholder={t('PlaceHolder_Filter_NumberNT_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditNT}
                              onChange={handleChangeFilterEditNT}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                             <TextField
                              id="numberNTTo" 
                              name="numberNTTo"
                              value={filtersNT.numberNTTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsfiltersNT.numberNTTo!=null?t(errorsfiltersNT.numberNTTo):t('Text_Filter_NumberNT_To')}
                              placeholder={t('PlaceHolder_Filter_NumberNT_To')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditNT}
                              onChange={handleChangeFilterEditNT}/>
                           </div>
                         
                          <div className="form-group">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                              <DesktopDatePicker
                                  id="dateSheetFrom" 
                                  name="dateSheetFrom"
                                  value={ filtersNT.dateSheetFrom!== null ? new Date(filtersNT.dateSheetFrom): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsfiltersNT.dateSheetFrom!=null?t(errorsfiltersNT.dateSheetFrom):t('PlaceHolder_Filter_DateSheet_From')}
                                  onBlur={handleBlurSelectDateNTFrom}
                                  onChange={handleChangeSelectDateNT}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                <DesktopDatePicker
                                  id="dateSheetTo" 
                                  name="dateSheetTo"
                                  minDate={filtersNT.dateSheetFrom!== null ? new Date(filtersNT.dateSheetFrom): null}
                                  value={ filtersNT.dateSheetTo!== null ? new Date(filtersNT.dateSheetTo): null}
                                  format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                  label={errorsfiltersNT.dateSheetTo!=null?t(errorsfiltersNT.dateSheetTo):t('PlaceHolder_Filter_DateSheet_To')}
                                  onBlur={handleBlurSelectDateNTTo}
                                  onChange={handleChangeSelectDateNTTo}
                                  slotProps={{
                                    textField: {
                                      placeholder: i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy",
                                      sx: {
                                        color: '#1565c0',
                                        maxLength: '100',
                                        width: 430,  
                                        fontSize: '18px'
                                      },
                                      InputProps: {
                                        style: {
                                          fontSize: '18px',
                                        }
                                      },
                                      InputLabelProps:{ 
                                        style: {
                                          fontSize: '18px', 
                                          background: '#FFFFFF'
                                        }
                                      },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                          </div>           
                          <div className="form-group">
                            {/* Campo de texto para escribir y filtrar */}
                            <span style={{ position: "relative" }}>
                              <TextField
                                id="ori_tras_store_idFrom"
                                name="ori_tras_store_idFrom"
                                value={filtersNT.ori_tras_store_idFrom}
                                onChange={(e) => {
                                  setFiltersNT(prev => ({
                                    ...prev,
                                    ori_tras_store_idFrom: e.target.value.toUpperCase(),
                                    ori_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchOriTrasStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownOriTrasStoreFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsfiltersNT.ori_tras_store_idFrom != null
                                  ? t(errorsfiltersNT.ori_tras_store_idFrom)
                                  : t('Text_Filter_OriTras_From')}
                                placeholder={t('PlaceHolder_Filter_OriTras_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredOriTrasStoreFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredOriTrasStoreFrom.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectOriTrasStoreFrom(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexOriTrasStoreFrom ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOriTrasStoreFrom ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )} 
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                              <TextField
                                id="ori_tras_store_idTo"
                                name="ori_tras_store_idTo"
                                value={filtersNT.ori_tras_store_idTo}
                                onChange={(e) => {
                                  setFiltersNT(prev => ({
                                    ...prev,
                                    ori_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchOriTrasStoreTo(e.target.value);
                                }}
                                onKeyDown={handleKeyDownOriTrasStoreTo}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsfiltersNT.ori_tras_store_idTo != null
                                  ? t(errorsfiltersNT.ori_tras_store_idTo)
                                  : t('Text_Filter_OriTras_To')}
                                placeholder={t('PlaceHoldert_Filter_OriTras_To')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              />
                              {filteredOriTrasStoreTo.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left: '0px',
                                    border: "2px solid #4e73df",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa",
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  {filteredOriTrasStoreTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                      onClick={() => handleSelectOriTrasStoreTo(store)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor: index === highlightedIndexOriTrasStoreTo ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexOriTrasStoreTo ? "white" : "black",
                                      }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>
                          </div> 
                            
                          <div className="form-group">
                            <span style={{ position: "relative" }}>
                            {/* Campo de texto para escribir y filtrar */}
                              <TextField
                                id="dest_tras_store_idFrom"
                                name="dest_tras_store_idFrom"
                                value={filtersNT.dest_tras_store_idFrom}
                                onChange={(e) => {
                                  setFiltersNT(prev => ({
                                    ...prev,
                                    dest_tras_store_idFrom: e.target.value.toUpperCase(),
                                    dest_tras_store_idTo: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchDestTrasStoreFrom(e.target.value);
                                }}
                                onKeyDown={handleKeyDownTransFrom}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errorsfiltersNT.dest_tras_store_idFrom != null
                                  ? t(errorsfiltersNT.dest_tras_store_idFrom)
                                  : t('Text_Filter_DestTras_From')}
                                placeholder={t('PlaceHolder_Filter_DestTras_From')}
                                inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                variant="outlined"
                              /> 
                              {/* Desplegable dinámico */}
                              {filteredTransFrom.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredTransFrom.map((store, index) => (
                                    <MenuItem
                                        key={store.id}
                                        onClick={() => handleSelectDestTrasStoreFrom(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === filteredDestTrasStoreTo ? "#4e73df" : "transparent",
                                            color: index === filteredDestTrasStoreTo ? "white" : "black",
                                        }}
                                    >
                                      {store.documentid} - {store.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                              </span>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                              <span style={{ position: "relative" }} >
                                <TextField
                                  id="dest_tras_store_idTo"
                                  name="dest_tras_store_idTo"
                                  value={filtersNT.dest_tras_store_idTo}
                                  onChange={(e) => {
                                    setFiltersNT(prev => ({
                                      ...prev,
                                      dest_tras_store_idTo: e.target.value.toUpperCase() 
                                    }));
                                    debouncedHandleSearchDestTrasStoreTo(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownDesrTrasStoreTo}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsfiltersNT.dest_tras_store_idTo != null
                                    ? t(errorsfiltersNT.dest_tras_store_idTo)
                                    : t('Text_Filter_DestTras_To')}
                                  placeholder={t('PlaceHolder_Filter_DestTras_To')}
                                  inputProps={{ style: { width: 400, fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                  variant="outlined"
                                />  
                                {/* Desplegable dinámico */}
                                {filteredTransTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                  {filteredTransTo.map((store, index) => (
                                    <MenuItem
                                      key={store.id}
                                        onClick={() => handleSelectDestTrasStoreTo(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexDestTrasStoreTo ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexDestTrasStoreTo ? "white" : "black",
                                        }}
                                      >
                                        {store.documentid} - {store.tradename}
                                      </MenuItem>
                                  ))}
                                </div>
                              )}
                            </span>  
                          </div>          
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditNT}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeletefiltersNT}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div>    
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
              </div>
              }  
              <NTPDF 
                rowEditNT={rowEditNT} 
                viewPDF={viewPDF} 
                setViewPDF={setViewPDF}
              /> 
              <Dialog
                open={openVideoHelpStore}
                onClose={() => setOpenVideoHelpStore(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  style: {
                    borderRadius: "20px",
                    overflow: "hidden"
                  }
                }}
              >
                <DialogTitle
                  sx={{
                    color: "#4e73df",
                    fontWeight: 500,
                    fontSize: "1.4rem"
                  }}
                >
                  {t('Text_Video_Explain_NT').toUpperCase()}
                </DialogTitle> 
                <DialogContent sx={{ padding: 0, background: "#000" }}>
                  <div className="store-video-wrapper">
                    <iframe
                      width="100%"
                      height="100%"
                      src={STORE_VIDEO_URL}
                      title={t('Text_Video_Explain')}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                </DialogContent>

                <DialogActions sx={{ padding: "12px 20px" }}>
                  <Button
                    onClick={() => setOpenVideoHelpStore(false)}
                    className="my-dialog-button-cancel"
                  >
                    {t('Button_Close')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog open={openDeleteRowNT} onClose={handleCancelDeleteRowNT} PaperProps={{ className: "my-dialog-paper-danger" }} >
                <DialogTitle className="my-dialog-title-danger">
                  {t('Text_Delete')} {rowEditNT.id}  - {rowEditNT.number_nt} - {rowEditNT.opt_tras_tradename} 
                </DialogTitle>
                  <DialogContent>
                    <DialogContentText className="my-dialog-contentText-danger">
                      {t("Text_Line1")}<br />
                      {t("Text_Line2")}
                    </DialogContentText>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="idCode"
                        label={t("Text_Label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        className="my-dialog-input-danger"
                        defaultValue={idCodeDelete}
                        onChange={handleChangeDeleteRowNT}
                      />
                    </DialogContent>
                  <DialogActions className="my-dialog-actions">
                  <Button
                    onClick={handleCancelDeleteRowNT}
                    className="my-dialog-button-cancel-danger"
                  >
                    {t("Button_Cancel")}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloseDeleteRowNT}
                    className="my-dialog-button-delete"
                  >
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog> 

              <Dialog
                open={openErrorRowNT}
                onClose={handleCancelErrorRowNT}
                maxWidth="md"
                fullWidth
                classes={{
                  paper: rowEditNT.statussentesir>=3 ? "esir-dialog-paper success" : "esir-dialog-paper error"
                }}
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { className: "esir-dialog-backdrop" } }}
              >
                <DialogTitle
                  className={`esir-dialog-title ${
                    rowEditNT.statussentesir>=3 ? "esir-dialog-title--ok" : "esir-dialog-title--error"
                  }`}
                >
                  {rowEditNT.statussentesir>=3 ? t("Text_Successful_Send") : t("TextResulut_Send")}
                  <small>{rowEditNT.number_nt}</small>
                </DialogTitle> 
                <div className="esir-dialog-titlebar" /> 
                {rowEditNT.statussentesir<3 &&
                  <DialogContent dividers className="esir-dialog-content">
                    <div className="esir-dialog-content-inner">
                       <Textarea 
                        id="reasonrefund" 
                        name="reasonrefund"
                        value={rowEditNT.reasonrefund}
                        className="esir-textarea"
                        variant="standard"
                        maxRows={8}
                        disabled
                      />   
                    </div>
                  </DialogContent> 
                }
                <DialogActions className="esir-dialog-actions">
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={handleCancelErrorRowNT}
                    className={`esir-dialog-btn-close ${rowEditNT.statussentesir>=3 ? 'success' : ''}`}
                  >
                    {t('Button_Exit')}
                  </Button>
                </DialogActions> 
              </Dialog>  
              {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

NTFilter.propTypes = {
  showModalNTSettings: PropTypes.bool.isRequired,
  setShowModalNTSettings: PropTypes.func.isRequired
};

export default NTFilter;
